// extracted by mini-css-extract-plugin
export default {"title":"jntYrWkp","description":"Ta7NIhsG","method":"nNXdNTf_","text":"Lt16xwo0","tooltip":"xuAhRG3j","button":"uDf__o_c"};